
import 'enquire';

const enquire = window.enquire || 'undefined';

const MediaQueries = {

    queries: {
        'megamenu--small': 'screen and (max-width: 1023px)',
        'megamenu--large': 'screen and (min-width: 1024px)'
    },

    register: function (config) {
        if (Object.prototype.toString.call(config) === '[object Array]') {
            for (let i = 0; i < config.length; i++) {
                const currentConfig = config[i];
                this._addToHandler(currentConfig);
            }
        } else {
            this._addToHandler(config);
        }
    },

    _addToHandler: function (config) {

        if (enquire !== 'undefined') {
            enquire.register(config.queries, {
                match: config.match,
                unmatch: config.unmatch,
                deferSetup: true
            }, config.shouldDegrade).listen(250);
        }
    }
};

export { MediaQueries };
